import React from "react"
import PropTypes from "prop-types"
import { Col, Row, Card, CardImg } from "reactstrap"
import { Link } from "react-router-dom"

const UgiftEmptyState = props => (
  <Row>
    <Col>
      <Card
        className="mb-0 shadow-none p-3"
        style={{
          borderRadius: "0px",
          // width: "160px",
          // height: "196px",
          backgroundColor: "transparent",
        }}
      >
        <CardImg
          top
          className="img-fluid px-5"
          src={props.image}
          alt=""
          // style={{
          //   // aspectRatio: "3/2",
          //   objectFit: "cover",
          // }}
        />
        <span
          className="font-size-15 p-3 pt-0 text-center mb-3 mt-2"
          style={{ color: "#C5CEE0" }}
        >
          {props.title}
        </span>
        {props.link && (
          <Row className="px-3">
            <Link
              to={props.link}
              className="btn btn-danger waves-effect waves-light font-size-18"
              // style={{ height: "42px" }}
            >
              {props.linkText}
            </Link>
          </Row>
        )}
      </Card>
    </Col>
  </Row>
)

export default UgiftEmptyState
